import React from 'react';
import { Formik } from 'formik';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FieldLayoutSmall, ButtonDisplayErrors, ButtonErrorMessage } from 'cstar-react-primitives';


import { cashbotName } from '../../../core';
import { useUsers } from '../../../../user/UserContext';
import { useOrder } from '../../../../mapi/OrderProvider';
import { useFormatMessage } from '../../../../intl/intlHooks';
import { getTotalValue } from '../../../../lineItem/lineItemSelectors';
import { OrderSummaryTotalsPoints } from '../../../orderSummary/OrderSummaryTotalsPoints';

import { AgreeToTermsField, TERMS_AGREEMENT } from '../../../forms/fields/AgreeToTermsField';

import { creditCardFormMessages } from '../creditCard/creditCardFormMessages';

import { getValidationSchema } from './pointsValidation';

export const PointsForm = ({ handleSubmit, totalValue, setFieldValue, errors }) => {
    const formatMessage = useFormatMessage();

    const buttonProps = {
        type: 'submit',
        btnText: formatMessage(creditCardFormMessages.checkoutButtonText),
        formName: cashbotName,
        isSmall: false,
        cashbotName
    };

    const { termsAgreement, ...newErrors } = errors;
    const errorMessage = newErrors && !termsAgreement ? newErrors[Object.keys(newErrors)[0]] : '';

    return (
        <form onSubmit={handleSubmit}>
            <FieldLayoutSmall isCentered>
                <OrderSummaryTotalsPoints totalValue={totalValue} />
                <AgreeToTermsField clickHandler={val => setFieldValue(TERMS_AGREEMENT, val)} />
                <div className="checkout-actions">
                    <ButtonDisplayErrors {...buttonProps}>
                        {errors && <ButtonErrorMessage errorMessage={errorMessage} iconType="error" />}
                    </ButtonDisplayErrors>
                </div>
            </FieldLayoutSmall>
        </form>
    );
};

PointsForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    values: PropTypes.object.isRequired,
    setFieldValue: PropTypes.func.isRequired,
    totalValue: PropTypes.number.isRequired,
    errors: PropTypes.object.isRequired
};

/* eslint react/no-children-prop: 0 */
export const PointsFormik = props => {
    const { placeOrder } = useOrder();
    const { totalValue } = props;
    const { userData } = useUsers();

    const initialValues = {
        paymentMethod: 'sap',
        countryCode: 'US',
        [TERMS_AGREEMENT]: false,
        currencyCode: userData.currency || 'USD'
    };

    const handleSubmit = values => {
        values.firstName = userData.firstName;
        values.lastName = userData.lastName;
        values.fullName = `${userData.firstName} ${userData.lastName}`;
        values.senderName = `${userData.firstName} ${userData.lastName}`;
        values.email = userData.email;
        placeOrder(values);
    };

    const validationSchema = getValidationSchema(useFormatMessage());

    return (
        <Formik
            onSubmit={values => handleSubmit(values)}
            initialValues={initialValues}
            validationSchema={validationSchema}
            children={formProps => <PointsForm totalValue={totalValue} {...formProps} />}
        />
    );
};

PointsFormik.propTypes = {
    totalValue: PropTypes.number.isRequired
};

const mapStateToProps = state => ({
    totalValue: getTotalValue(state)
});

export default connect(mapStateToProps)(PointsFormik);
